<template>
  <horizontal-bar-chart
      style="width: 100%; height:400px"
      :chartData="getChartData"
      :options="getOptions"/>
</template>

<script>
import HorizontalBarChart from '@/components/oeeAnalytics/charts/horizontalBarChart'
import {mapGetters} from "vuex";
import timeCalc from "@/mixins/timeCalc";
import generalMethods from "@/mixins/insights/generalMethods";
import downTimesOee from '@/mixins/oeeAnalytics/downTimes'
import colours from "@/mixins/oeeAnalytics/colours";
export default {
  components: {
    HorizontalBarChart
  },
  mixins: [timeCalc, generalMethods, downTimesOee,colours],
  props: ['downTimes', 'uniqueReasons'],
  data() {
    return {
      config: {}
    }
  },
  computed: {
    ...mapGetters('users', ['getClaims']),
    getOptions() {
      const self = this
      return {

        animation: {
          duration: 0 // general animation time
        },
        hover: {
          animationDuration: 100,
          intersect:false,// duration of animations when hovering an item
        },

        layout: {
          padding: {
            left: 20,
            right: 50,
            top: 0,
            bottom: 0
          }
        },
        title: {
          display: true,
          text: self.$t('oeeAnalytics.downTimes.topBottom.chartTitle'),
          fontSize: 18,
          fontStyle: 'normal',
          position: 'top',
        },
        scales: {
          yAxes: [
            {
              ticks: {
                // Include a dollar sign in the ticks
                callback: function (value, index, ticks) {
                  return value[value.length - 1] //
                }
              },
              gridLines: {
                display: false
              },
            },
          ],
          xAxes: [{
            gridLines: {
              display: true
            },
            ticks: {
              beginAtZero: true,
            }
          }],
        },
        legend: {
          display: false,
        },
        //This will show money in tooltip with format of $xx.xx
        tooltips: {
          callbacks: {
            title: function (tooltip) {
              return tooltip[0].label
            },
            label: function (tooltipItem) {
              console.log(tooltipItem.value)
              return parseFloat(tooltipItem.value).toFixed(1)+' %'    //tooltipItem.value
            }
          }
        },
        plugins: {
          datalabels: {
            color: '#464646',
            anchor: 'end',
            align: 'right',
            font: {
              // weight: 'bold',
              size: 15
            },
            offset: 3,

            display: function (ctx) {
              // return false
              return true //ctx.datasetIndex >   0 //ctx.chart.$totalizer.utmost;
            },
            formatter: (value, ctx) => {
              if (parseInt(value) > 0) {
                return '+' + value.toFixed(0) + '%'
              } else if (parseInt(value) < 0) {
                return value.toFixed(0) + '%'
              } else {
                return '0%'
              }
            },

          }
        },
        responsive: true,
        maintainAspectRatio: false,
        onClick: function (evt, el) {
          console.log(self.joinReasonsToString(el[0]._model.label))
          try {
            self.$emit('reasonSelected', self.joinReasonsToString(el[0]._model.label))
          } catch (e) {
            self.$emit('reasonSelected', null)
          }
        },
        onHover: (event, chartElement) => {
          event.target.style.cursor = chartElement[0] ? 'pointer' : 'default';
        },
      }

    },
    getUniqueKeys() {
      return this.getUniqueDownTimeKeys();
    },
    getDownTimes() {
      let downTimes = _.clone(this.downTimes)
      if (this.config.filterByValue) {
        return this.getFilteredDownTimes
      }
      return downTimes
    },


    getChartData() {
      let labels = this.uniqueReasons
      let topDataSet = this.getTopDowntimes(labels)

      let colours = topDataSet.data.map((value, idx) => {
        return value > 0 ? this.getBottomColour : this.getTopColour
      });
      if (colours.length == 9) {
        colours.push(
            topDataSet.data[topDataSet.data.length - 1] > 0 ? this.getBottomColour : this.getTopColour
        )
      }

      let filterdDownTime = this.uniqueReasons.length == 1
      let lengthOfData = Math.floor(topDataSet.data.length / 2) > 5 ? 5 : Math.floor(topDataSet.data.length / 2)

      let datasets = [
        {
          label: 'Top',
          backgroundColor: [..._.take(colours, lengthOfData), ..._.takeRight(colours, lengthOfData)],
          data: [
            ..._.take(topDataSet.data, lengthOfData),
            ..._.takeRight(topDataSet.data, lengthOfData)]
        }
      ]

      if (filterdDownTime) {
        return {
          labels: [..._.take(topDataSet.labels, 5)],
          datasets: [
            {
              label: 'Top',
              backgroundColor: topDataSet.data > 0 ? this.getBottomColour : this.getTopColour,
              data: [
                ..._.take(topDataSet.data, 5)]
            }

          ]
        }
      } else {

        return {
          labels: [..._.take(topDataSet.labels, lengthOfData), ..._.takeRight(topDataSet.labels, lengthOfData)],
          datasets,
        }
      }
    },
  },
  methods: {
    getTopDowntimes(labels) {
      // crate new array based on length
      let data = new Array(labels.length).fill(0)

      let groupped = _.groupBy(this.downTimes, dt => {
        return this.joinReasonsToString(dt)
      })

      _.forEach(groupped, (dt, key) => {
        let index = _.findIndex(labels, l => {
          return l === key
        })
        if (index >= 0) {
          if (dt[0].averageDownTimeForReason) {
            data[index] = _.meanBy(dt, 'duration') / (parseInt(dt[0].averageDownTimeForReason)) * 100 - 100
          }
        }
      })


      const arrayOfObj = labels.map(function (d, i) {
        return {
          label: d,
          data: data[i],
        }
      })

      const sortedArrayOfObj = arrayOfObj.sort(function (a, b) {
        return a.data - b.data
        // return a.data - b.data
      })
      let newArrayLabel = []
      let newArrayData = []
      sortedArrayOfObj.forEach(function (d) {

        newArrayLabel.push(d.label)
        newArrayData.push(d.data)

      })
      // for (let i = 0; i < newArrayData.length; i++) {
      //   if (i > 4) {
      //     newArrayData[i] = 0 - newArrayData[i]
      //   }
      // }
      for (let i = 0; i < newArrayLabel.length; i++) {
        newArrayLabel[i] = this.splitReasonsToString(newArrayLabel[i])
        // newArrayLabel[i] = newArrayLabel[i]
      }


      return {
        labels: newArrayLabel,
        data: newArrayData,
      }
    },

  },
  watch: {},
  created() {
  }
}
</script>


<style scoped lang="scss">
@import "./src/assets/scss/components/insights/_generalStylingCharts.scss";
</style>